import { ErrorCode } from 'react-dropzone';

import { UPLOADING_DENTAL_VIDEO_MAX_SIZE } from '@/shared/config';

export const validateDentalVideoFileSize = (file: File) => {
  if (file.size > UPLOADING_DENTAL_VIDEO_MAX_SIZE) {
    return {
      code: ErrorCode.FileTooLarge,
      message: `File is larger than ${UPLOADING_DENTAL_VIDEO_MAX_SIZE} bytes`,
    };
  }

  return null;
};
